// treeReferenceSlice.js
// Здесь будет описание редьюсера treeReferenceSlice

export default function treeReferenceSlice(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
